export const getRevenueCentersDisplay = (revenueCenters) => {
  switch(revenueCenters) {
    case null:
      return "All"
    case '':
    case undefined:
      return "None"
    default:
      return revenueCenters.length
  }
}
